
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/service/contact",
      function () {
        return require("private-next-pages/[lang]/service/contact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/service/contact"])
      });
    }
  